import { rem } from "polished";

const tabletWidth = rem("768px");
const megaPhoneWidth = rem("900px");
const desktopWidth = rem("1054px");

/**
 * Breakpoint for page wrapper change
 * * Separate orientation widths to accommodate mega phones
 * @constant
 * @default
 * @type {number}
 */
export const BREAKPOINT_WRAPPER = `only screen and (min-width: ${tabletWidth}) and (orientation: portrait), (min-width: ${megaPhoneWidth}) and (orientation: landscape)`;

/**
 * Breakpoint for page wrapper change on HiDPI screens
 * * Separate orientation widths to accommodate mega phones
 * @constant
 * @default
 * @type {number}
 */
export const BREAKPOINT_WRAPPER_HIDPI = `only screen and (-webkit-min-device-pixel-ratio: 2) and (min-width: ${tabletWidth}) and (orientation: portrait), only screen and (min-resolution: 192dpi) and (min-width: ${megaPhoneWidth}) and (orientation: landscape)`;

/**
 * Breakpoint for desktop screens
 * @constant
 * @default
 * @type {string}
 */
export const BREAKPOINT_DESKTOP = `only screen and (min-width: ${desktopWidth})`;

/**
 * Breakpoint for tablet screens *
 *
 * Previously as `min-width: ${rem("768px")}`, but this resulted
 * in broken styles on large landscape phones. Made this an
 * alias of `BREAKPOINT_WRAPPER` to avoid code churn. Updated
 * all media query constants to use rem units since old iOS
 * devices are no longer supported.
 *
 * @constant
 * @default
 * @type {string}
 */
export const BREAKPOINT_TABLET = BREAKPOINT_WRAPPER;

/**
 * Breakpoint for only tablet screens
 *
 * @constant
 * @default
 * @type {string}
 */
export const BREAKPOINT_TABLET_ONLY = `only screen and (min-width: ${tabletWidth}) and (max-width: ${desktopWidth}) and (orientation: portrait), (min-width: ${megaPhoneWidth}) and (max-width: ${desktopWidth}) and (orientation: landscape)`;
